import { Page } from '@hakimo-ui/hakimo/ui-layout';
import { useUser } from '@hakimo-ui/hakimo/util';
import { TabItem, Tabs } from '@hakimo-ui/shared/ui-base';
import { ReactNode } from 'react';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { AlarmNotifications } from './alarm-notifications/AlarmNotifications';
import General from './general/General';
import Preferences from './preferences/Preferences';
import { tabItems } from './util';

interface Props {
  extraTabs?: TabItem<string>[];
  extraRoutes?: ReactNode;
}

export function UserProfileRoot(props: Props = {}) {
  const { extraTabs = [], extraRoutes } = props;
  const user = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  const items: TabItem<string>[] = [...tabItems, ...extraTabs];
  const currentSegment = location.pathname.split('/').filter(Boolean).pop();
  const activeTabId =
    items.find((t) => t.id === currentSegment)?.id ?? 'general';

  const onChangeTab = (tabId: string) => {
    navigate(`/profile/${tabId}`);
  };

  return (
    <Page title="Settings" titleFontSize="large">
      <Tabs items={items} activeTabId={activeTabId} onChange={onChangeTab} />
      <div className="mx-auto w-full">
        <Routes>
          <Route path="/" element={<Navigate to="general" />} />
          <Route path="general" element={<General user={user} />} />
          <Route path="preferences" element={<Preferences />} />
          <Route path="alarm-notifications" element={<AlarmNotifications />} />
          {extraRoutes}
        </Routes>
      </div>
    </Page>
  );
}

export default UserProfileRoot;
